import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  gap: 2.5rem;
`;
